import { useGateway } from '@ad-lucy/gateway-provider';
import { lazy } from 'react';

const RemoteMediaPlanning = lazy(
  () => import('@modules/remotes/mediaplanning'),
);

function AdmModuleMediaPlanning() {
  const gateway = useGateway();

  return <RemoteMediaPlanning gateway={gateway} />;
}

export default AdmModuleMediaPlanning;
